import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { storiesOf } from '@storybook/react';
import { AutomatedReports } from './AutomatedReports';

storiesOf('Manage Alerts/AutomatedReports', module)
  .add('View', () => (
    <AutomatedReports />
  ));



/** WEBPACK FOOTER **
 ** ./src/components/searchAlerts/AutomatedReports/AutomtatedReports.stories.jsx
 **/